import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { DialogContent } from "@mui/material"

import { useAppDispatch } from "redux/hooks"
import { withModalDebt, withModalPaymentSchedule } from "hocs/features"
import { closeDialog } from "redux/features/dialog/dialogSlice"
import { Container, Headline } from "components/PaymentSchedule/elements"
import Close from "components/ui/ModalClose"
import Title from "components/PaymentSchedule/Title"
import Download from "components/PaymentSchedule/Download"
import Invoices from "components/PaymentSchedule/Invoices"
import Notice from "components/ui/Notice"
import { DebtType, PaymentScheduleType } from "types"

type Props = {
  debt: DebtType
  payment_schedule: PaymentScheduleType
}

const PaymentScheduleViewComponent = ({ debt, payment_schedule }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { reference_number } = debt
  const { payment_schedule_invoices } = payment_schedule

  const handleClose = () => {
    dispatch(closeDialog())
    navigate("/")
  }

  return (
    <DialogContent>
      <Close onClick={handleClose} />
      <Container
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Headline>
          <Title reference_number={reference_number}>
            {t("features.payment_schedule.title")}
          </Title>
          <Download debt={debt} paymentScheduleId={payment_schedule.id} />
        </Headline>
        <Invoices invoices={payment_schedule_invoices} />
        <Notice>{t("features.payment_schedule.notice.view")}</Notice>
      </Container>
    </DialogContent>
  )
}

export default compose<ComponentType>(
  withModalDebt,
  withModalPaymentSchedule,
)(PaymentScheduleViewComponent)
